import { createPortal } from "react-dom";
import React from "react";

export default function ModalPortal({ children }) {
  // Garantiza que montamos en <body>; si hay SSR, podrías añadir una guarda de window
  return createPortal(children, document.body);
}
